import { devtoolsExchange } from '@urql/devtools';
import { authExchange } from '@urql/exchange-auth';
import { GetServerSidePropsContext, NextPageContext } from 'next';
import { Translate } from 'next-translate';
import { ClientOptions, fetchExchange, SSRExchange } from 'urql';
import { getAuthExchangeOptions } from 'urql/authExchange';
import cache from 'urql/cacheExchange';
import { dedupExchange } from 'urql/dedupExchange';
import { getErrorExchange } from 'urql/errorExchange';
import { operationNameExchange } from 'urql/operationNameExchange';

export const getUrqlExchanges = (
    ssrExchange: SSRExchange,
    t: Translate,
    context?: GetServerSidePropsContext | NextPageContext,
): ClientOptions['exchanges'] => [
    devtoolsExchange,
    dedupExchange,
    cache,
    getErrorExchange(t, context),
    ssrExchange,
    authExchange(getAuthExchangeOptions(context)),
    operationNameExchange,
    fetchExchange,
];
